export const useBrowserUserId = () => {
  const browserUserId = localStorage.getItem('browserUserId');
  if (!browserUserId) {
    const newBrowserUserId = crypto.randomUUID();
    localStorage.setItem('browserUserId', newBrowserUserId);
    return newBrowserUserId;
  }
  return browserUserId;
};
